module.exports = __webpack_public_path__ + "static/logo-ce278a089c1697da9c3c8215512ef74d.png";